import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    cancelledApplications,
    completedApplications,
    liveApplications,
} from '€slices/applications';
import { Box, Typography } from '@material-ui/core';
import ApplicationsTable from '€components/ApplicationsTable';
import Tabs from '€components/Tabs';
import NoApplicationsMessage from '€components/NoApplicationsMessage';
import { filterPropsMap } from '€lib/application/filterPropsMap';
import formatDate from '€lib/strings/dateFormat';
import poundFormat from '€lib/strings/poundFormat';
import { useStyles } from './styles';
import { ActiveTab, TabValue } from '~/src/types';

const ApplicationsList: React.FC = () => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState('inProgress');
    const liveApps = useSelector(liveApplications);
    const completedApps = useSelector(completedApplications);
    const cancelledApps = useSelector(cancelledApplications);

    const tabValues: TabValue[] = [
        {
            index: '0',
            value: ActiveTab.InProgress,
            label: 'IN PROGRESS',
        },
        {
            index: '1',
            value: ActiveTab.Completed,
            label: 'COMPLETED',
        },
        {
            index: '2',
            value: ActiveTab.Cancelled,
            label: 'CANCELLED',
        },
    ];

    const currentTabDataSelector = useMemo(() => {
        let filteredApps = [];
        if (activeTab === ActiveTab.InProgress) {
            filteredApps = liveApps;
        } else if (activeTab === ActiveTab.Completed) {
            filteredApps = completedApps;
        } else if (activeTab === ActiveTab.Cancelled) {
            filteredApps = cancelledApps;
        }

        return [
            ...filterPropsMap(filteredApps, [
                'applicationId',
                'applicantLastName',
                'createdAt',
                'salesPipelineStage',
                'actualLoanAmount',
                'applicationTypeNameInternal',
                'loanTypeName',
                'lenderName',
                'campaignName',
                'commissionReceivedDate',
                'introducerFee',
                'clickRef',
                'turnedDownReason',
            ]),
        ].map(app => ({
            ...app,
            commissionReceivedDate: app.commissionReceivedDate
                ? formatDate(app.commissionReceivedDate, 'dd-MM-yyyy')
                : null,
            createdAt: app.createdAt ? formatDate(app.createdAt, 'dd-MM-yyyy') : null,
            introducerFee: app.introducerFee ? poundFormat(app.introducerFee, true) : null,
            actualLoanAmount: app.actualLoanAmount ? poundFormat(app.actualLoanAmount, true) : null,
        }));
    }, [activeTab, liveApps, completedApps]);

    return (
        <>
            <Box mt={4} mb={['0.9375rem', '1.25rem']}>
                <Typography className={classes.title} variant="h2">
                    Case List
                </Typography>
            </Box>
            <Tabs tabs={tabValues} activeTab={activeTab} setTab={setActiveTab} />
            {currentTabDataSelector.length ? (
                <ApplicationsTable applications={currentTabDataSelector} />
            ) : (
                <NoApplicationsMessage
                    label={tabValues.find(tab => tab.value === activeTab).label}
                />
            )}
        </>
    );
};

export default ApplicationsList;
